import { useState } from 'react'
import { Form, Field, FormElement } from '@progress/kendo-react-form'
import { FormInput, FormSwitch } from '../FormComponents'
import { requiredValidator, nameValidator } from '../Validators'
import { submitSite } from '../../../data/siteData'
import { getAccountRef } from '../../../data/clientData'

import {
  ExpansionPanel,
  ExpansionPanelContent,
} from '@progress/kendo-react-layout'
import { Reveal } from '@progress/kendo-react-animation'

const AddClientForm = (props: any) => {
  const [accountRef, setAccountRef] = useState('')
  const [expandRequired, setExpandRequired] = useState(true)
  const [expandOptional, setExpandOptional] = useState(false)
  const [clientName, setClientName] = useState('')

  const [createSiteToggle, setCreateSiteToggle] = useState(false)

  const handleCreateSiteToggle = (e: any) => {
    setCreateSiteToggle(e.value)
  }

  const fetchAccountRef = async (client: string) => {
    await getAccountRef(client).then((result) => {
      setAccountRef(result)
    })
  }

  const handleRefGenerate = async () => {
    if(clientName !== '') {
      fetchAccountRef(clientName)
    } else {
      alert('Please enter a client name before generating a reference.')
    }
  }

  const newSiteHandler = (dataItem: any) => {
    const siteObj = {
        siteAddr: dataItem.clientAddr,
        postcode: dataItem.postcode,
    }
    submitSite(siteObj)
  };

  const handleSubmit = (dataItem: any) => {
    // alert(JSON.stringify(dataItem, null, 2));
    dataItem.accountRef = accountRef
    if (createSiteToggle) {
      newSiteHandler(dataItem)
    }
    props.onClientSubmit(dataItem)
  }

  return (
    <Form
      initialValues={{
        accountRef: accountRef,
      }}
      onSubmit={handleSubmit}
      render={(formRenderProps) => (
        <FormElement style={{ padding: '1rem', marginBottom: '5rem' }}>
          <fieldset className={'k-form-fieldset'}>
            <div className='form__subtitle' style={{ marginBottom: '1em' }}>
              Add client details:
              <button
                className='form__reset__button'
                onClick={formRenderProps.onFormReset}
              >
                Clear fields
              </button>
            </div>

            <ExpansionPanel
              title='Required Fields'
              expandIcon='fa fa-plus'
              collapseIcon='fa fa-minus'
              expanded={expandRequired}
              onAction={(e) => setExpandRequired(!e.expanded)}
              style={{ marginBottom: '1rem' }}
            >
              <Reveal>
                {expandRequired && (
                  <ExpansionPanelContent>
                    <Field
                      name={'clientName'}
                      component={FormInput}
                      label={'Client Name:'}
                      placeholder={'Enter a client name:'}
                      validator={nameValidator}
                      onChange={(e: any) => {
                        setClientName(e.value)
                      }}
                    />

                    <Field
                      name={'contactFirstName'}
                      component={FormInput}
                      label={'Contact First Name'}
                      placeholder={'Enter a client contact full name:'}
                      validator={requiredValidator}
                    />

                    <Field
                      name={'contactLastName'}
                      component={FormInput}
                      label={'Contact Last Name'}
                      placeholder={'Enter a client contact full name:'}
                      validator={requiredValidator}
                    />

                    <Field
                      name={'email'}
                      component={FormInput}
                      label={'Email Address:'}
                      placeholder={'Enter a client contact email address:'}
                      validator={requiredValidator}
                    />

                    <Field
                      name={'phone'}
                      component={FormInput}
                      label={'Phone Number:'}
                      placeholder={'Enter a client contact phone number:'}
                      validator={requiredValidator}
                    />

                    <Field
                      name={'clientAddr'}
                      component={FormInput}
                      label={'Address:'}
                      placeholder={'Enter a client site address:'}
                      validator={requiredValidator}
                    />

                    <Field
                      name={'postcode'}
                      component={FormInput}
                      label={'Postcode:'}
                      placeholder={'Enter a client postcode:'}
                      validator={requiredValidator}
                    />

                    <Field
                      name={'accountRef'}
                      component={FormInput}
                      label={'Account Reference:'}
                      placeholder={accountRef}
                      defaultText={accountRef}
                      hasButton={true}
                      buttonText={'Generate Reference'}
                      buttonAction={handleRefGenerate}
                    />

                    <Field
                      name={'siteCreateToggle'}
                      component={FormSwitch}
                      label={'Create site with same address:'}
                      onChange={handleCreateSiteToggle}
                    />
                  </ExpansionPanelContent>
                )}
              </Reveal>
            </ExpansionPanel>

            <ExpansionPanel
              title='Optional Fields'
              expandIcon='fa fa-plus'
              collapseIcon='fa fa-minus'
              expanded={expandOptional}
              onAction={(e) => setExpandOptional(!e.expanded)}
            >
              <Reveal>
                {expandOptional && (
                  <ExpansionPanelContent>
                    <Field
                      name={'phone2'}
                      component={FormInput}
                      label={'Secondary Phone:'}
                      placeholder={'(If required) Enter a second number:'}
                    />

                    <Field
                      name={'fax'}
                      component={FormInput}
                      label={'Fax Address:'}
                      placeholder={'Enter a client fax address:'}
                    />

                    <Field
                      name={'tradeContact'}
                      component={FormInput}
                      label={'Trade Contact:'}
                      placeholder={'Enter a client trade contact:'}
                    />

                    <Field
                      name={'email2'}
                      component={FormInput}
                      label={'Second Email Address:'}
                      placeholder={
                        '(If required) Enter a second contact email address:'
                      }
                    />

                    <Field
                      name={'email3'}
                      component={FormInput}
                      label={'Third Email Address:'}
                      placeholder={
                        '(If required) Enter a third contact email address:'
                      }
                    />

                    <Field
                      name={'websiteUrl'}
                      component={FormInput}
                      label={'Website Address:'}
                      placeholder={'Enter a client website address:'}
                    />

                    <Field
                      name={'vatNum'}
                      component={FormInput}
                      label={'VAT Number:'}
                      placeholder={'Enter a client VAT number:'}
                    />

                    <Field
                      name={'directdebitEmail'}
                      component={FormInput}
                      label={'Direct Debit Email Address:'}
                      placeholder={'Enter a client direct debit email address:'}
                    />
                  </ExpansionPanelContent>
                )}
              </Reveal>
            </ExpansionPanel>
          </fieldset>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              left: 0,
              width: '100%',
              paddingTop: '1rem',
              position: 'relative',
              zIndex: '100000',
            }}
          >
            <button
              type={'submit'}
              disabled={!formRenderProps.allowSubmit}
              style={{
                width: '100%',
                marginTop: '0.5rem',
                height: '3rem',
                backgroundColor: 'rgb(174 199 65)',
                color: 'rgb(71 83 21)',
                border: 0,
                borderRadius: '0.3rem',
              }}
            >
              Add client
            </button>
          </div>
        </FormElement>
      )}
    />
  )
}

export default AddClientForm
